import type { MindMapAggregateDto } from "@mmm/contracts";

/** Read-only SVG of persisted map content, shared by page and export previews. */
export function MapDiagram({ aggregate, className = "" }: { aggregate: MindMapAggregateDto; className?: string }) {
  const nodes = aggregate.nodes;
  if (nodes.length === 0) return null;

  const minX = Math.min(...nodes.map((node) => node.x));
  const minY = Math.min(...nodes.map((node) => node.y));
  const maxX = Math.max(...nodes.map((node) => node.x + node.width));
  const maxY = Math.max(...nodes.map((node) => node.y + node.height));
  const padding = 24;
  const viewBox = `${minX - padding} ${minY - padding} ${maxX - minX + padding * 2} ${maxY - minY + padding * 2}`;
  const nodesById = new Map(nodes.map((node) => [node.id, node]));

  return (
    <svg className={`mmm-export-map-diagram ${className}`.trim()} viewBox={viewBox} aria-hidden="true" focusable="false">
      {aggregate.relationships.map((relationship) => {
        const from = nodesById.get(relationship.fromNodeId);
        const to = nodesById.get(relationship.toNodeId);
        if (!from || !to) return null;
        return (
          <line
            key={relationship.id}
            x1={from.x + from.width / 2}
            y1={from.y + from.height / 2}
            x2={to.x + to.width / 2}
            y2={to.y + to.height / 2}
            stroke={relationship.stroke}
            strokeWidth="2.5"
          />
        );
      })}
      {nodes.map((node) => (
        <g key={node.id}>
          <rect x={node.x} y={node.y} width={node.width} height={node.height} rx="9" className="mmm-export-map-node" />
          <rect x={node.x} y={node.y} width="5" height={node.height} rx="2" fill={node.color} />
          <foreignObject x={node.x + 8} y={node.y + 4} width={Math.max(0, node.width - 12)} height={Math.max(0, node.height - 8)}>
            <div className="mmm-export-map-node-title">{node.title}</div>
          </foreignObject>
        </g>
      ))}
    </svg>
  );
}
